import "../../assets/css/carousel.scss";
import "../../assets/css/grid.scss";
import "../../assets/css/style.scss";
import Header from "../layout/Header";
import Faq from "../common/Faq";
import Footer from "../layout/Footer";
import Pricing from "../common/Pricing";
import Bannergiveaway from "../common/Bannergiveaway";
import GiveawayListStatic from "../common/GiveawayListStatic";

// Public "/Giveaway" listing page. The list of giveaways itself is
// rendered by the shared, dark-themed GiveawayListStatic component
// (see components/common/GiveawayListStatic), which fetches active
// giveaways from the API directly.
// The old inline card markup lives in GiveawayPage.backup.js for reference.
function GiveawayPage() {
  return (
    <div className="App">
      <Header />
      <Bannergiveaway />
      <GiveawayListStatic />
      <Faq />
      <Pricing />
      <Footer />
    </div>
  );
}

export default GiveawayPage;
